import React from "react";

import makeDomProvider, { DomContext } from "./context/Dom";
import { WindowDimensionsProvider } from "./context/WindowSize";

type Args = DomContext;

export default function makeSeneKitProvider(args: Args) {
  const DomProvider = makeDomProvider(args);

  return function SeneKitProvider({ children }: { children: React.ReactNode }) {
    return (
      <DomProvider>
        <WindowDimensionsProvider>{children}</WindowDimensionsProvider>
      </DomProvider>
    );
  };
}
